module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjY2NjY2IiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICAgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA5NiA5NiIKICAgICBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA5NiA5NiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CgogIDxwb2x5Z29uIHBvaW50cz0iOTYsMTQgODIsMCA0OCwzNCAxNCwwCiAgICAgICAgICAgMCwxNCAzNCw0OCAwLDgyIDE0LDk2IDQ4LDYyIDgyLDk2IDk2LDgyIDYyLDQ4Ij4KICA8L3BvbHlnb24+Cgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/remove-button.svg
// module id = OtMP
// module chunks = 0